import React, { useContext, useEffect, useState, useRef } from "react";
import FroalaEditor from "react-froala-wysiwyg";
import Froalaeditor from "froala-editor";
import { Spinner, SpinnerSize } from "@fluentui/react";
import studyReportContext from "../../../../../context/studyreport/StudyReportContext";
import '../../Styles/ReportVersion.css';
import { t } from "i18next";
import themeContext from "../../../../../context/theme/ThemeContext";
import { getEnv } from '../../../../../helpers/EnvHelper';

const NonEditableEditor = (props) => {

  const [editorLoaded,setEditorLoaded] = useState(false);
  const [disableAddendumTab, setDisableAddendDumTab] = useState(!props?.data?.[props.activeTabIndex]?.addendum?.trim());
  const [activeTabValue,setActiveTabValue] = useState(1);
  const { getThemeColor,getAlterColor,themeName } = useContext(themeContext);

  useEffect(()=>{
    setActiveTabValue(1);
    //setAddendumModel(props?.data[props.activeTabIndex]?.addendum);
    if(!props?.data?.[props.activeTabIndex]?.addendum?.trim()){
        setDisableAddendDumTab(true);
    }else{
      setDisableAddendDumTab(false);
    }
  },[props.activeTabIndex])
 

  const emptyConfig = {
    placeholderText: "No report content available.",
    key: getEnv("REACT_APP_FROALA_API_KEY"),
    attribution: false,
    height: props.customHeight,
    editable: false,
    width: 700,
    toolbarButtons: {
        // Customize your toolbar buttons as needed
        moreText: {
          buttons: [],
          align: 'left',
          buttonsVisible: 3,
        },
      },
      events: {
        "initialized": function (e) {
            console.log("-- initialziing");
          },
      },
  };

  const customSpinnerStyle = {
    circle: {
      height: "20px",
      width: "20px",
      borderWidth: "3px",
    },
  };


  return (
    <div className="new-editor-section">
      {props.studyReportPdfSelected ?  
      <div style={{width:'100%',height:500, display:'flex', justifyContent:'center', alignItems:'center'}}>
        <iframe
          src={props.studyReportPdfUrl}
          title="Study Report PDF"
          style={{
            width: "100%",
            height: "100%",
            border: "none",
          }}
        />
      </div>
      :
      <>
      <div className="tab-add-refresh-section-non-editor">
        <div className="custom-tab-section">
          <button
            className={`custom-tab-report-history study-list-final-report-border-left custom-tab-hover ${activeTabValue == 1?"active-tab-report":""}`}
            style={{background: activeTabValue == 1?getAlterColor("rgb(85 84 84)","rgb(117 117 117)"):getThemeColor('report-not-active-tab')}}
            onClick={() => {
              //setEditReport(true);
              setActiveTabValue(1);
            }}
          >
            <span className="custom-tab-text">{t("label.final-report")}</span>
          </button>
          <button
            style={{ cursor: disableAddendumTab?"not-allowed":"pointer",background:getAlterColor("rgb(51 50 50)","rgb(161 161 161)") }}
            className={`custom-tab-report-history study-list-final-report-border-right ${!disableAddendumTab ? "custom-tab-hover":""} ${activeTabValue == 2?"active-tab-report":""}`}  
            onClick={() => {
            //   setEditReport(true);
            if(!disableAddendumTab)
               setActiveTabValue(2);
            }}
          >
            <span className="custom-tab-text">{t("label.addendum")}</span>
          </button>
        </div>
      </div>
      {activeTabValue == 1 && <div className="modal-scroll-annotation" style={{overflow:'auto',colorScheme:`${themeName==='light'?'none':'inherit'}`}}><FroalaEditor
                      tag='textarea'
                      config={emptyConfig}
                      model={props?.data[props.activeTabIndex]?.finalReport}
                      key={"Non-editable-editor"}
                  /></div>}
      { activeTabValue == 2 && <div className="modal-scroll-annotation" style={{overflow:'auto'}}>
                  <FroalaEditor
                  tag='textarea'
                  config={emptyConfig}
                  model={props?.data[props.activeTabIndex]?.addendum}
                  key={"Non-editable-addendum-editor"}
              /></div>}
      </>
    }
    </div>
  );
};

export default NonEditableEditor;
